export enum UserLookupFilterEnum {
  SomenteAtivos = 0,
  SomenteInativos = 1,
  Todos = 2,
  ComExcluidos = 3,
}
